import React, { useState, useEffect } from 'react';
import { animated, useSpring } from "@react-spring/web";

const Banner = ({ bgimage, bgimageSmall, title, color }) => {
    const getInitialImage = () => {
        return window.innerWidth <= 768 ? bgimageSmall : bgimage;
    };

    const [bannerImage, setBannerImage] = useState(getInitialImage);

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth <= 768) {
                setBannerImage(bgimageSmall);
            } else {
                setBannerImage(bgimage);
            }
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [bgimage, bgimageSmall])

    const bannerStyle = {
        backgroundImage: `url(${bannerImage})`,
        color: color
    }

    const AnimatedHeading = () => {
        const styles = useSpring({
          from: { opacity: 0, transform: "translateX(50%)" },
          to: { opacity: 1, transform: "translateX(0)" },
          config: { duration: 1000 },
        });
    
        return <animated.h2 style={styles}>{title}</animated.h2>;
      };

    return <section className="banner" style={bannerStyle}>
        <span>
            <p>SHOPPING WITH STYLE</p>
        </span>
        <AnimatedHeading>{title}</AnimatedHeading>
    </section>
}

export default Banner;